import { useSelector } from 'react-redux';

import { getSelectedReasonDocument } from '../model';

export const useSkipDocuments = (): boolean => {
	const selectedReasonDocument = useSelector(getSelectedReasonDocument);

	return !selectedReasonDocument;
};
